import { useEffect, useState } from "react";
import { BACKOFFICE_BASE_URL } from "../../../services/TapApiUrls";
import { useSelector } from "react-redux";
import HttpAPICall from "../../../services/HttpAPICall";
import Loader from "../../../components/ui/Loader/Loader";
import TapSelect from "../../../components/ui/TapSelect";
import tapIcon from '../../../services/TapIcon';
import ApplicationLayout from "../../../layouts/ApplicationLayout";
import { Helmet } from "react-helmet";
import Ax from "../../../components/hoc/Ax";
import { toast } from "react-toastify";

export default function AssetSCSAdd({history, location}) {

    const assetSCSUrl           =   BACKOFFICE_BASE_URL + '/scs';
    const access_token          =   useSelector(state => state.auth.access_token);

    const initAddModelForm  =   {
        name                    :   '',   
        asset_type_id           :   '',
        section_id              :   '',
        sub_section_id          :   '',
        description             :   ''
    };
    
    const [addModelForm, setAddModelForm] = useState({ ...initAddModelForm });
    const [saveFormSubmitting, setSaveFormSubmitting]   =   useState(false);
    const [formDataLoading, setFormDataLoading] =   useState(false);
    const [formData, setFormData]   =   useState({
        allData         :   [],
        assetType       :   [],
        sections        :   [],
        allSectionData  :   [],
        subSections     :   [],
    });
    const [editId, setEditId]       =   useState(null)
    const [nameExit, setNameExit]   =   useState(false);
    const [editName, setEditName]   =   useState('');
    const [searchExitName, setSearchExitName] = useState(false);

    useEffect(() => {
        initFormData()
    }, []);

    useEffect(() => {
        if(editId) {
            detailData(editId);
        }
    }, [editId])

    const initFormData  =   ()  =>  {
        setFormDataLoading(true);
        setNameExit(false);
        HttpAPICall.withAthorization('GET', assetSCSUrl + '/form_data', access_token, {}, {}, (resp) => {
            const res       =   resp.data;
            setFormData(pre => ({
                ...pre,
                allData     :   res,
                assetType   :   res.map(d => ({label : d.asset_type_name, value: d.id}))
            }));
        }).then(() => {
            const queryParams = new URLSearchParams(location.search);
            if(queryParams && queryParams.get('asset_scs_id')) {
                setEditId(queryParams.get('asset_scs_id'));
            }else {
                setFormDataLoading(false)
            }
        });
    }

    const detailData    =   (id) => {
        HttpAPICall.withAthorization('GET', assetSCSUrl + '/detail/' + id, access_token, {}, {}, (resp) => {
            const respData  =   resp.data;
            const sections  =   formData.allData.find(at => at.id == respData.asset_type.id).sections;
            
            const subSections=  respData.section ? sections.find(s => s.id == respData.section.id).sub_sections.map(s => ({label : s.subcomponent, value: s.id})) : [];
            setFormData(pre => ({
                ...pre, 
                sections : sections && sections.length > 0 ? sections.map(s => ({label : s.component, value: s.id})) : [], 
                subSections
            }));

            setAddModelForm({
                name            :   respData.name,   
                asset_type_id   :   respData.asset_type.id,
                section_id      :   respData.section.id,
                sub_section_id  :   respData.sub_section?.id,
                description     :   respData.description
            })

        })
        .finally(() => setFormDataLoading(false));
    }

    const submitDataForm = (e) => {
        e.preventDefault();
        setSaveFormSubmitting(true);
        let method  =   'POST';
        let url     =   assetSCSUrl + '/add';
        let payload =   addModelForm;
        if(editId) {
            method  =   'PUT';
            url     =   assetSCSUrl + '/edit';
            payload =   {...payload, id : editId};
        }

        HttpAPICall.withAthorization(method, url, access_token, {}, payload, (resp) => {
            toast.success(resp.data.msg, { position: toast.POSITION.TOP_RIGHT });
            goToList();
        }).catch((error) => {
            toast.error(error.response?.data?.msg || "An error occurred", { position: toast.POSITION.TOP_RIGHT });
        }).finally(() => {
            setSaveFormSubmitting(false);
        });
    };

    const goToList  =   ()  => {
        setAddModelForm(initAddModelForm);
        setEditId(null);
        setEditName('');
        setNameExit('');
        setNameExit(false);
        history.push('/asset_scs_list');
    }

    const handleBlur    =   ()  => {
        const {asset_type_name} = addModelForm
        if(asset_type_name && asset_type_name !== editName) {
            setEditName(asset_type_name);
            setSearchExitName(true);
            HttpAPICall.withAthorization('GET', assetSCSUrl + '/with_name?asset_type_name=' + asset_type_name, access_token, {}, {}, (resp) => {
                if(resp.data > 0) {
                    setNameExit(true)
                }else {
                    setNameExit(false)
                }
            }).then(() => setSearchExitName(false));
        }
    }

    const handleAssetTypeSelect =   (selectedOption) => {
        if(selectedOption) {
            setAddModelForm(pre => ({...pre, asset_type_id : selectedOption.value, section_id: '', sub_section_id: ''}));
            const allSectionData    =   formData.allData.find(at => at.id === selectedOption.value).sections;
            const sections          =   allSectionData.map(s => ({label : s.component, value : s.id}));
            setFormData(pre => ({...pre, sections, allSectionData, subSections : []}));
        }else {
            setAddModelForm(pre => ({...pre, asset_type_id : '', section_id : '', sub_section_id: ''}));
            setFormData(pre => ({...pre, sections: [], subSections: []}));
        }
    }

    const handleSectionSelect   =   (selectedOption) => {
        if(selectedOption) {
            const subSections       =   formData.allSectionData.find(s => s.id === selectedOption.value)?.sub_sections.map(sb => ({label : sb.subcomponent, value : sb.id}));
            setFormData(pre => ({...pre, subSections}));
            setAddModelForm(pre => ({...pre, section_id : selectedOption.value, sub_section_id: '' }))
        }else {
            setAddModelForm(pre => ({...pre, section_id : '', sub_section_id: ''}));
            setFormData(pre => ({...pre, subSections : []}));
        }
    }


    const saveFormJsx   =   ()  =>  {
        return(
            <form className="bg-white p-3" onSubmit={submitDataForm} id="saveResourceForm">
                {formDataLoading ? <Loader />
                    : <>
                        <div className="row align-items-center my-3">
                            <div className="col-sm-3">
                                <label htmlFor="name" className="form-label require">Service Checksheet Name</label>
                            </div>
                            <div className="col-sm-6 ">
                                <input
                                    name="name"
                                    type="text"
                                    value={addModelForm.name}
                                    className="form-control"
                                    autoComplete="off"
                                    required={true}
                                    onChange={(e) => {
                                        setAddModelForm(pre => ({...pre, [e.target.name] : e.target.value}))
                                    }}
                                    // onBlur={handleBlur}
                                    placeholder="Please Enter Name"
                                />
                            {
                                nameExit && 
                                    <span className="text-danger">* Asset Type not available,try another</span>
                            }
                            </div>
                        </div>

                        <div className="row align-items-center my-3">
                            <div className="col-sm-3">
                                <label htmlFor="path" className="form-label require">Asset Type</label>
                            </div>
                            <div className="col-sm-6 ">
                                <TapSelect
                                    changeEvent={(selectedOption) => {
                                        handleAssetTypeSelect(selectedOption)
                                    }}
                                    options={formData.assetType}
                                    isSearchable={true}
                                    isClearable={true}
                                    required={true}
                                    value={formData.assetType.find(s => addModelForm.asset_type_id === s.value)}
                                    placeholder="Please Select Asset Type"
                                />
                            </div>
                        </div>

                        <div className="row align-items-center my-3">
                            <div className="col-sm-3">
                                <label htmlFor="path" className="form-label require">Section</label>
                            </div>
                            <div className="col-sm-6 ">
                                <TapSelect
                                    changeEvent={(selectedOption) => {
                                        handleSectionSelect(selectedOption)
                                    }}
                                    options={formData.sections}
                                    isSearchable={true}
                                    isClearable={true}
                                    required={true}
                                    value={formData.sections?.find(s => addModelForm.section_id === s.value)}
                                    placeholder="Please Select Section"
                                />
                            </div>
                        </div>

                        <div className="row align-items-center my-3">
                            <div className="col-sm-3">
                                <label htmlFor="path" className="form-label">Sub Section</label>
                            </div>
                            <div className="col-sm-6 ">
                                <TapSelect
                                    changeEvent={(selectedOption) => {
                                        if(selectedOption) {
                                            console.log(selectedOption);
                                            
                                            setAddModelForm(pre => ({...pre, sub_section_id : selectedOption.value }))
                                        }else {
                                            setAddModelForm(pre => ({...pre, sub_section_id : ''}))
                                        }
                                    }}
                                    options={formData.subSections}
                                    isSearchable={true}
                                    isClearable={true}
                                    value={formData.subSections?.find(s => addModelForm.sub_section_id === s.value)}
                                    placeholder="Please Select Sub Section"
                                />
                            </div>
                        </div>

                        <div className="row align-items-center my-3">
                            <div className="col-sm-3">
                                <label htmlFor="path" className="form-label">Description</label>
                            </div>
                            <div className="col-sm-6 ">
                                <textarea
                                    name="description"
                                    className="form-control"
                                    rows="3"
                                    // style={{width:"100%"}}
                                    onChange={(e) => {
                                        setAddModelForm(pre => ({...pre, [e.target.name] : e.target.value}))
                                    }}
                                    value={addModelForm.description}
                                    placeholder="Description "
                                />
                            </div>
                        </div>

                    </>}
                <div className="col-12 text-end fixed_footer">
                    <button type="button" disabled={saveFormSubmitting} onClick={goToList} className="btn btn-secondary mx-3">Cancel</button>
                    <button type="submit" disabled={saveFormSubmitting || formDataLoading || searchExitName} className="btn btn-primary mx-2">
                        Save {saveFormSubmitting ? (<tapIcon.FontAwesomeIcon icon={tapIcon.faSyncAlt} className="fa-spin" />) : ''}
                    </button>
                </div>
            </form>
        )
    } 


  return (
    <ApplicationLayout>
        <Helmet><title>Service Checksheet Add</title></Helmet>
        <div className="page_title row m0">
            <div className="col-12">
                <h3>{editId ? "Edit" : "Add"} Service Checksheet</h3>
                <div className="text-end mt15">
                    <button type="button" className="btn btn-secondary" onClick={goToList}>
                        <tapIcon.imageIcon icon={tapIcon.CloseIcon} className="img-fluid" alt="Close Asset Type" />
                    </button>
                </div>
            </div>
        </div>
        {/* onClick={closeEvent} disabled={saveFormSubmitting} */}
        <div className="container-fluid">
            <div className="page_containt row pl2">
                <div className="pageTbl col-12 pl4">
                    {saveFormJsx()}
                </div>
            </div>
        </div>
    </ApplicationLayout>
  )
}
